export default {"src":"/my-nerdwallet-next/_next/static/media/warning.66fcefd4.svg","height":24,"width":18,"blurWidth":0,"blurHeight":0};